import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { DietTrackerApp } from "../ui";
import { initializeTheme } from "../ui/theme";
import { bootstrapApplication } from "./bootstrap";

initializeTheme();

const container = document.getElementById("root");
if (!container) throw new Error("Application root element is missing");

const root = createRoot(container);
root.render(
  <main className="startup-screen" aria-live="polite">
    <strong>Diet Tracker</strong>
    <p>Opening your local diary...</p>
  </main>,
);

try {
  const controller = await bootstrapApplication();
  root.render(
    <StrictMode>
      <DietTrackerApp controller={controller} />
    </StrictMode>,
  );
} catch (error) {
  const message = error instanceof Error ? error.message : "The application could not be opened.";
  root.render(
    <main className="startup-screen startup-screen--error" role="alert">
      <strong>Diet Tracker could not start</strong>
      <p>{message}</p>
      <button type="button" onClick={() => window.location.reload()}>Try again</button>
    </main>,
  );
}
